import { Alert, Container } from "@mui/material";
import React from "react";
import useApiEp from "../../hooks/useApiEp";
import LoadingWidget from "../../widgets/LoadingWidget";
import { getErrorResponse } from "../../utils/util";

const ZohoAuth = () => {
  const { data, isLoading, isError, error } = useApiEp(`/payment/get-auth-url`);
  if (isLoading) {
    return <LoadingWidget label="Loading data..." />;
  }
  if (isError) {
    return <Alert>{getErrorResponse(error)}</Alert>;
  }
  return (
    <Container sx={{ mt: 3 }}>
      <a href={data.url} target="_blank">
        Auth Link
      </a>
    </Container>
  );
};

export default ZohoAuth;
